import "./styles.scss";

import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

import { Nav, Actions, Call, Location, Contact } from "./components";
import Social from "components/Social";

const Menu = ({ isOpen, isContactOpen }) => {
  const [submenu, setSubmenu] = useState("nav");

  const getSubmenu = (type) => {
    switch (type) {
      case "call":
        return <Call />;
      case "location":
        return <Location />;
      default:
        return <Nav />;
    }
  };

  useEffect(() => {
    if (submenu && !isOpen) {
      setSubmenu("nav");
    }
  }, [submenu, isOpen]);

  return (
    <AnimatePresence>
      {(isOpen || isContactOpen) && (
        <motion.div
          className="header-mobile-menu"
          initial={{ opacity: 1, clipPath: "circle(0% at 100% 0%)" }}
          animate={{ opacity: 1, clipPath: "circle(150% at 100% 0%)" }}
          exit={{ opacity: 0, clipPath: "circle(150% at 100% 0%)" }}
          transition={{
            opacity: {
              type: "tween",
              duration: 0.3,
            },
            clipPath: {
              type: "tween",
              ease: "easeInOut",
              duration: 0.5,
            },
          }}
        >
          <div className="header-mobile-menu__body">
            {isContactOpen ? (
              <Contact />
            ) : (
              <>
                <AnimatePresence exitBeforeEnter initial={false}>
                  <motion.div
                    key={submenu}
                    className="header-mobile-menu__body-inner"
                    initial={{ opacity: 0, height: "25%" }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: "25%" }}
                    transition={{
                      type: "tween",
                      ease: "easeInOut",
                      duration: 0.4,
                    }}
                  >
                    {submenu !== "nav" && (
                      <button
                        className="header-mobile-menu__back"
                        type="button"
                        onClick={() => setSubmenu("nav")}
                      >
                        Wróć
                      </button>
                    )}
                    {getSubmenu(submenu)}
                  </motion.div>
                </AnimatePresence>

                <Actions onClick={(type) => setSubmenu(type)} />
              </>
            )}
          </div>
          <div className="header-mobile-menu__footer">
            <Social />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Menu;
